import { jsx as _jsx } from "react/jsx-runtime";
export var TextSkeleton = function () {
    return _jsx("div", { className: 'h-4 bg-vjwSecondary rounded w-3/4 m-2 animate-pulse' });
};
